// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_schoolPage__Vrqjf {
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 400px;
}

.styles_title__JlR1d {
  font-size: 20px;
  font-weight: 600;
  color: var(--color-text-primary);
  margin: 0;
}

.styles_description__Qoaxt {
  font-size: 14px;
  color: var(--color-text-secondary);
  margin: 0;
}
.styles_description__Qoaxt strong {
  color: var(--color-text-primary);
}

.styles_dropdownWrapper__ZgECd {
  margin-top: 8px;
}

.styles_message__mwq4K {
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 14px;
}
.styles_message__mwq4K.styles_success__IVUTn {
  background-color: rgba(34, 197, 94, 0.1);
  color: #16a34a;
  border: 1px solid rgba(34, 197, 94, 0.3);
}
.styles_message__mwq4K.styles_error__jYxPJ {
  background-color: rgba(239, 68, 68, 0.1);
  color: #dc2626;
  border: 1px solid rgba(239, 68, 68, 0.3);
}`, "",{"version":3,"sources":["webpack://./src/components/school-profile-page/styles.module.scss"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,eAAA;EACA,gBAAA;EACA,gCAAA;EACA,SAAA;AAAF;;AAGA;EACE,eAAA;EACA,kCAAA;EACA,SAAA;AAAF;AAEE;EACE,gCAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AADF;AAGE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AADJ;AAIE;EACE,wCAAA;EACA,cAAA;EACA,wCAAA;AAFJ","sourcesContent":["@import \"mixins\";\n.schoolPage {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 400px;\n}\n\n.title {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--color-text-primary);\n  margin: 0;\n}\n\n.description {\n  font-size: 14px;\n  color: var(--color-text-secondary);\n  margin: 0;\n\n  strong {\n    color: var(--color-text-primary);\n  }\n}\n\n.dropdownWrapper {\n  margin-top: 8px;\n}\n\n.message {\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 14px;\n\n  &.success {\n    background-color: rgba(34, 197, 94, 0.1);\n    color: #16a34a;\n    border: 1px solid rgba(34, 197, 94, 0.3);\n  }\n\n  &.error {\n    background-color: rgba(239, 68, 68, 0.1);\n    color: #dc2626;\n    border: 1px solid rgba(239, 68, 68, 0.3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"schoolPage": `styles_schoolPage__Vrqjf`,
	"title": `styles_title__JlR1d`,
	"description": `styles_description__Qoaxt`,
	"dropdownWrapper": `styles_dropdownWrapper__ZgECd`,
	"message": `styles_message__mwq4K`,
	"success": `styles_success__IVUTn`,
	"error": `styles_error__jYxPJ`
};
export default ___CSS_LOADER_EXPORT___;
